import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleIntegrerIAISO27001() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Intégrer l'IA dans une démarche ISO 27001"
      date="5 janvier 2027"
      ctaTitle="Intégrez l'IA dans votre démarche de conformité"
      ctaText="Le diagnostic couvre l'IA aux côtés de vos autres exigences ISO 27001, dans un plan d'action unique."
    >
      <p style={s.intro}>
        Si votre entreprise s'engage dans une démarche ISO 27001, l'IA ne doit pas rester un angle mort de
        votre système de management de la sécurité de l'information (SMSI). Elle s'y intègre naturellement,
        à condition de l'aborder explicitement.
      </p>

      <h2 style={s.h2}>Élargir votre cartographie des actifs</h2>
      <p>
        Un SMSI démarre par une cartographie des actifs et des processus critiques. Les systèmes d'IA utilisés
        par l'entreprise — qu'ils soient développés en interne ou fournis par un tiers — doivent y figurer au
        même titre que vos autres systèmes d'information.
      </p>

      <h2 style={s.h2}>Étendre votre analyse de risques</h2>
      <p>
        Les risques spécifiques à l'IA (dépendance fournisseur, prompt injection, qualité des données) doivent
        être intégrés à votre analyse de risques globale, selon la même méthode que celle décrite dans notre
        article sur la
        {' '}<Link to="/blog/gestion-des-risques-cybersecurite-methode-commune" style={s.link}>gestion des risques commune aux trois référentiels</Link>.
      </p>

      <h2 style={s.h2}>Adapter vos politiques et procédures existantes</h2>
      <p>
        Plutôt que de créer une politique IA totalement séparée, il est souvent plus efficace d'étendre vos
        politiques existantes (gestion des accès, gestion des fournisseurs, classification des données) pour
        qu'elles couvrent explicitement les systèmes d'IA.
      </p>

      <h2 style={s.h2}>Documenter les contrôles spécifiques à l'IA</h2>
      <p>
        Certains contrôles méritent une attention particulière dans votre documentation SMSI : validation
        humaine des actions automatisées sensibles, revue périodique des fournisseurs d'IA, procédure de test
        face aux tentatives de manipulation des systèmes conversationnels.
      </p>

      <h2 style={s.h2}>Ne pas traiter l'IA comme un référentiel séparé</h2>
      <p>
        L'intérêt d'intégrer l'IA dans votre SMSI existant, plutôt que de créer une démarche parallèle, est
        d'éviter la duplication d'efforts et de garder une vision unique de vos risques — le même principe qui
        sous-tend notre article
        {' '}<Link to="/blog/rgpd-nis2-iso27001-differences" style={s.link}>RGPD, NIS2, ISO 27001 : quelles différences ?</Link>{' '}
        appliqué cette fois à l'IA plutôt qu'aux trois référentiels d'origine.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleIntegrerIAISO27001;
